<template>
  <div style="position: relative;">
    <span class="return" @click="$router.back()"><<返回</span>
    <div class="hello" ref="bfContainer"></div>
  </div>
</template>

<script>


import {BimfaceSDKLoader,BimfaceSDKLoaderConfig,Glodon} from 'bimfacesdkloader'

export default {
  name: 'HelloWorld',
  data () {
    return {
        
    }
  },
  mounted(){

    const dom = this.$refs.bfContainer;

    let viewer3D;
    let app;
    let model3D;
    let viewToken = this.$route.query.viewToken;
    // 初始化显示组件
    let options = new BimfaceSDKLoaderConfig();
    options.viewToken = viewToken;
   // BimfaceSDKLoader.load(options, successCallback, failureCallback);
    BimfaceSDKLoader.load(options).then((viewMetaData)=>{
      if (viewMetaData.viewType == "3DView") {
        // ======== 判断是否为3D模型 ========
        // 获取DOM元素
        let webAppConfig = new Glodon.Bimface.Application.WebApplication3DConfig();
        webAppConfig.domElement = dom;
         webAppConfig.Buttons = ["Home", "RectZoom","Walk","Annotation", "Measure", "Property", "Setting","FullScreen"];
        // 创建WebApplication
        app = new Glodon.Bimface.Application.WebApplication3D(webAppConfig);
        // 添加待显示的模型
        app.addView(viewToken);
        // 从WebApplication获取viewer3D对象
        viewer3D = app.getViewer();
        // 监听添加view完成的事件
        viewer3D.addEventListener(Glodon.Bimface.Viewer.Viewer3DEvent.ViewAdded, function () {
          // 调用viewer3D对象的Method，可以继续扩展功能
          //自适应屏幕大小
          window.onresize = function () {
            viewer3D.resize(document.documentElement.clientWidth, document.documentElement.clientHeight - 40)
          }
          // 从viewer3D对象中获取模型对象model3D
          model3D = viewer3D.getModel();
          // 渲染3D模型
          viewer3D.render();
        });
      }
    });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >
/deep/.gld-bf-information{
  display: none;
}
.return{
    position: absolute;
    top: 22px;
    right: 194px;
    z-index: 9999;
    font-size: 21px;
    color: #666;
    cursor: pointer;
}
h1, h2 {
  font-weight: normal;
}
.hello{
  height: 94vh;;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>




// WEBPACK FOOTER //
// src/views/View.vue